module.exports = __webpack_public_path__ + "media/images/folder--e58158c3b4266988cc98a28ce7527c29.png";